import { render, staticRenderFns } from "./updateGPMModal.vue?vue&type=template&id=2b3f5258&"
import script from "./updateGPMModal.vue?vue&type=script&lang=js&"
export * from "./updateGPMModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports